import React from "react";

function throttle(cb: () => void, ms: number) {
  let lastTime = 0;
  return () => {
    const now = Date.now();
    if (now - lastTime >= ms) {
      cb();
      lastTime = now;
    }
  };
}

export function useIdle(onIdle: () => void, seconds = 60) {
  React.useEffect(() => {
    const ms = seconds * 1000;
    let timeoutId: number;

    const handleTimeout = () => {
      onIdle();
    };

    const handleEvent = throttle(() => {
      window.clearTimeout(timeoutId);
      // eslint-disable-next-line no-console
      console.debug("User idle timeout scheduled", new Date(Date.now() + ms).toLocaleTimeString());
      timeoutId = window.setTimeout(handleTimeout, ms);
    }, 500);

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        handleEvent();
      }
    };

    // eslint-disable-next-line no-console
    console.debug("User idle timeout scheduled", new Date(Date.now() + ms).toLocaleTimeString());
    timeoutId = window.setTimeout(handleTimeout, ms);

    window.addEventListener("mousemove", handleEvent);
    window.addEventListener("mousedown", handleEvent);
    window.addEventListener("resize", handleEvent);
    window.addEventListener("keydown", handleEvent);
    window.addEventListener("touchstart", handleEvent);
    window.addEventListener("wheel", handleEvent);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("mousemove", handleEvent);
      window.removeEventListener("mousedown", handleEvent);
      window.removeEventListener("resize", handleEvent);
      window.removeEventListener("keydown", handleEvent);
      window.removeEventListener("touchstart", handleEvent);
      window.removeEventListener("wheel", handleEvent);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.clearTimeout(timeoutId);
    };
  }, [seconds, onIdle]);
}
